export const NO_ASSISTANCE = {
  id: 'no_assistance',
  label: 'Nessuna assistenza in corso di gravidanza',
};
export const OBSTETRIC_CONDUCTION_PHYSIOLOGICAL = {
  id: 'obstetric_conduction_physiological',
  label: 'Fisiologico a conduzione ostetrica',
};
export const PHYSIOLOGICAL_MEDICAL_MANAGEMENT = {
  id: 'physiological_medical_management',
  label: 'Fisiologico a conduzione medica',
};
export const PATHOLOGICAL = {
  id: 'pathological',
  label: 'Patologico per condizioni pregresse o insorte in gravidanza',
};
